import { render, staticRenderFns } from "./playground.vue?vue&type=template&id=2dadfc9f&scoped=true"
import script from "./playground.vue?vue&type=script&lang=js"
export * from "./playground.vue?vue&type=script&lang=js"
import style0 from "./playground.vue?vue&type=style&index=0&id=2dadfc9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dadfc9f",
  null
  
)

export default component.exports